export const BARRA_CATS = new Set([
  'cocktails', 'copas', 'cervezas', 'vinos', 'sin_alcohol',
  'refrescos', 'cervezas_botella', 'cervezas_grifo', 'zumos'
]);

export function round2(value) {
  return Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
}

export function formatMoney(value) {
  return `${Number(value || 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
}

export function prepStationOf(item) {
  const explicit = item?.prepStation || item?.productId?.prepStation;
  if (explicit === 'barra' || explicit === 'cocina') return explicit;
  const category = item?.category || item?.productId?.category || item?.categorySnapshot;
  return BARRA_CATS.has(category) ? 'barra' : 'cocina';
}

export function calculateInvoiceTotals(items) {
  const lines = (items || []).map((item) => {
    const quantity = Number(item.quantity || 0);
    const priceWithTax = round2(item.priceWithTax ?? item.priceWithTaxSnapshot ?? 0);
    const taxRate = Number(item.taxRate ?? 10);
    const total = round2(priceWithTax * quantity);
    const subtotal = round2(total / (1 + taxRate / 100));
    const taxAmount = round2(total - subtotal);
    return { ...item, quantity, priceWithTax, taxRate, total, subtotal, taxAmount };
  });
  const subtotal = round2(lines.reduce((sum, item) => sum + item.subtotal, 0));
  const total = round2(lines.reduce((sum, item) => sum + item.total, 0));
  let taxAmount = round2(lines.reduce((sum, item) => sum + item.taxAmount, 0));
  const diff = round2(total - subtotal - taxAmount);
  if (Math.abs(diff) <= 0.02) taxAmount = round2(taxAmount + diff);
  const taxBreakdown = [...lines.reduce((map, item) => {
    const key = String(item.taxRate);
    const row = map.get(key) || { rate: item.taxRate, base: 0, tax: 0, total: 0 };
    row.base = round2(row.base + item.subtotal);
    row.tax = round2(row.tax + item.taxAmount);
    row.total = round2(row.total + item.total);
    map.set(key, row);
    return map;
  }, new Map()).values()];
  return { lines, subtotal, taxAmount, total, taxBreakdown };
}

export function groupItemsByOrder(items = []) {
  return items.reduce((acc, item) => {
    const key = item.orderId;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});
}
